import { gql } from '@apollo/client';

export interface GqlInvitation {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  status: string;
  organizationId: string;
}

export interface GqlAcceptInviteResponse {
  invitation: GqlInvitation;
  error: string;
}

export const GqlInvitationFragment = gql`
  fragment InvitationFields on Invitation {
    __typename
    id
    email
    firstName
    organizationId
    lastName
    role
    status
  }
`;
